import { PRODUCTS } from 'src/utils/strings';

import type { ValidateResponse } from './validate-query';

export type LegacyLoginRequest = {
    username: string;
    password: string;
};

export type LegacyLoginResponse = {
    apiToken: string;
    subscriptionId: string;
} & ValidateResponse;

export const legacyLoginMutation = {
    query: ({ username, password }: LegacyLoginRequest) => ({
        url: '/mp/1/signin',
        method: 'PUT',
        body: {
            username,
            password,
            product: PRODUCTS.IMAGOADMIN,
        },
    }),
};
